import { produce } from 'immer'
import { combineReducers } from 'redux'
import ConversationLogCard from 'shared/src/typings/ConversationLogCard'
import { RoutingEntry } from 'shared/src/typings/RoutingAuditLog'
import { fetchRoutingAuditLogsAsync } from 'shared/store/actions/conversationLog'
import { showConversationLogsSidebar } from 'shared/store/actions/sidebar'

import { createReducer } from 'typesafe-actions'

const routingAuditLogByConversationId = createReducer<Record<number, RoutingEntry[] | undefined>>(
  {}
).handleAction([fetchRoutingAuditLogsAsync.success], (state, action) => {
  const {
    payload: { conversationId, response },
  } = action

  return produce(state, (draft) => {
    draft[conversationId] = response.conversationRoutingEntries
  })
})

const initialExpandedCard = createReducer<ConversationLogCard>(null).handleAction(
  showConversationLogsSidebar,
  (_, { payload }) => {
    return payload
  }
)

export default combineReducers({
  routingAuditLogByConversationId,
  initialExpandedCard,
})
